import React, { useContext, useEffect, useCallback } from 'react';
import InputField from '../../../common/forms/InputField';
import { ThemeStateContext, ThemeDispatchContext } from './CreateEditThemeProvider';
import CheckboxPicker from '../../../common/forms/CheckboxPicker';
import Body2 from '../../../common/typographys/Body2';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  label: {
    marginTop: '16px',
    marginBottom: '8px',
  },
}));

const FormInfoTheme = () => {
  const classes = useStyles();

  const {
    state: { name, isPublic, signatureBlock, errors },
  } = useContext(ThemeStateContext);
  const dispatch = useContext(ThemeDispatchContext);

  useEffect(() => {
    return () => {
      dispatch({
        type: 'CLEAR_STATE',
      });
    };
  }, [dispatch]);

  const updateField = useCallback(
    (nameInput, value) => {
      dispatch({
        type: 'UPDATE_FIELD',
        payload: {
          name: nameInput,
          value,
        },
      });
    },
    [dispatch]
  );

  return (
    <>
      <InputField label="Nome" name="name" value={name} onChange={e => updateField('name', e.target.value)} error={errors.name} />
      <CheckboxPicker label="Disponível" checked={isPublic} onClick={() => updateField('isPublic', !isPublic)} />
      <Body2 secondary className={classes.label}>Resumo de proposta</Body2>
      <InputField
        label="Bloco de assinatura"
        name="signatureBlock"
        value={signatureBlock}
        multiline
        rows="1"
        rowsMax="3"
        onChange={e => updateField('signatureBlock', e.target.value)}
        error={errors.signatureBlock}
      />
    </>
  );
};

export default FormInfoTheme;
